<template>
    <v-container>
        <v-row class="mx-1 mb-5 mt-1 heading-title">
            Email Settings
        </v-row>

        <v-row class="mx-1 mb-5 mt-1 content">
            User E-Mail addresses are used for emailing tickets and other system messages. For Locators, you must enable 'Email Assigned Tickets' to have assigned tickets automatically e-mailed to this address.
        </v-row>

        <v-row class="mx-1 mt-4">
            <v-col class="col col-md-6 p-0 pt-2">
                <v-text-field
                    v-model="email"
                    outlined
                    dense
                    placeholder="Email Address"
                    label="Email Address"
                    :rules="emailRules"
                />
            </v-col>
        </v-row>

        <v-row class="mx-1 mb-5 mt-1 content">
            If this user receives any tickets, specify the ticket format to send.
        </v-row>

        <v-row class="mx-1 mb-2">
            <v-col class="col col-md-6 p-0">
                <v-select
                    v-model="EMAIL_TICKET_FORMAT"
                    outlined
                    dense
                    label="Ticket Format"
                    item-text="name"
                    item-value="value"
                    :items="getCompanyOption"
                />
            </v-col>
        </v-row>

        <v-row class="mx-1 my-5 heading-title">
            Email Auto CC
        </v-row>
        <v-divider />

        <v-row class=" mb-5 mt-1 content">
            <v-col class="col col-md-9">
                E-Mail address entered here will automatically receive a copy of all e-mail this user receives.
            </v-col>
            <v-col class="col col-md-2">
                <AddEmailAddress
                    model-type="Add"
                    @add-email-address="addEmailAddress"
                />
            </v-col>
        </v-row>
        <v-row class="mb-3">
            <v-col class="col col-md-12">
                <v-card
                    v-if="!userEmailCC.length"
                    elevation="0"
                    class="no-email"
                >
                    <div>There are no E-mail ID added yet.</div>
                </v-card>
                <v-data-table
                    v-if="userEmailCC.length > 0"
                    id="email__addresses"
                    ref="email__addresses"
                    fixed-header
                    :headers="headers"
                    :items="userEmailCC"
                    item-key="id"
                    hide-default-footer
                >
                    <template v-slot:[`item.enabled`]="{item}">
                        {{ item.enabled ? 'YES' : 'NO' }}
                    </template>
                    <template v-slot:[`item.edit`]="{item}">
                        <AddEmailAddress
                            :email-details="item"
                            model-type="Edit"
                            @add-email-address="addEmailAddress"
                        />
                    </template>
                    <template v-slot:[`item.delete`]="{item}">
                        <v-icon
                            class="cp"
                            @click="deleteEmailAddressDialog(item)"
                        >
                            mdi-delete-outline
                        </v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog
            v-model="deleteUserDialog"
            hide-overlay
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 lighten-2">
                    <span>Delete</span>
                </v-card-title>
                <v-divider />
                <v-card-text class="my-4">
                    Are you sure you want to delete <span v-if="selectedItems">"{{ selectedItems.name }}"</span> user.
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        outlined
                        light
                        @click="cancelDeleteEmailAddressDialog()"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        style="text-transform: none !important"
                        depressed
                        color="primary"
                        @click="deleteEmailAddress(selectedItems)"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>

import webtmsBackend from '@/services/webtmsBackend';
import AddEmailAddress from './AddEmailAddress';
import { guidEqual } from '@/utils/guid.js';

export default {
    name: 'EmailSettings',
    components: {
        AddEmailAddress
    },
    data: () => ({
        deleteUserDialog: false,
        selectedItems: null,
        userEmailCC: [],
        deletedEmail: [],
        email: '',
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        EMAIL_TICKET_FORMAT: 'ORIGINAL',
        headers: [
            {
                text: 'Enable',
                value: 'enabled',
                align: 'left',
                width: '100px',
                sortable: false,
            },
            {
                text: 'Name',
                value: 'name',
                align: 'left',
                width: '250px',
                sortable: false,
            },
            {
                text: 'Email',
                value: 'email',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Edit',
                value: 'edit',
                align: 'center',
                width: '30px',
                sortable: false,
            },
            {
                text: 'Delete',
                value: 'delete',
                align: 'center',
                width: '30px',
                sortable: false,
            },
        ],
    }),
    computed: {
        getUserDetails() {
            return this.$store.getters.user;
        },
        getCompanyOptions() {
            return this.$store.getters.companyOptions;
        },
        getEditUser() {
            return this.$store.getters.editUser;
        },
        getCompanyOption() {
            if(this.getCompanyOptions) {
                let companyOptions = this.getCompanyOptions.find((item) => item.option === 'TICKET_FORMAT_LIST');
                if(companyOptions) {
                    let companyOption = companyOptions.value.split(',');
                    companyOption = companyOption.map(item => {
                        switch(item) {
                            case 'ALERT_EMAIL':
                                return {
                                    name: 'Original HTML',
                                    value: item
                                };
                            case 'ALERT_SMS':
                                return {
                                    name: 'Original Transmission',
                                    value: item
                                };
                            case 'SMSTEXT':
                                return {
                                    name: 'SMS/TEXT Format',
                                    value: item
                                };
                            case 'COMPANY_1':
                                return {
                                    name: 'COMPANY Format 1',
                                    value: item
                                };
                            case 'COMPANY_2':
                                return {
                                    name: 'COMPANY Format 2',
                                    value: item
                                };
                            case 'COMPANY_3':
                                return {
                                    name: 'COMPANY Format 3',
                                    value: item
                                };
                            case 'COMPANY_4':
                                return {
                                    name: 'COMPANY Format 4',
                                    value: item
                                };

                        }
                    });
                    companyOption.unshift({
                        name: 'Original Text',
                        value: 'ORIGINAL'
                    });
                    return companyOption;
                }
            }
            return [];
        },
    },
    created() {
        this.setFormData();
    },
    methods: {
        setFormData() {
            if(this.$route.query.id) { 
                this.isEditUser = true;
            }
            if(this.getEditUser) {
                if(this.getEditUser.email) {
                    this.email = this.getEditUser.email;
                }
                if(this.getEditUser.userEmailCC) {
                    this.userEmailCC = this.getEditUser.userEmailCC;
                }
                if(this.getEditUser.userOptions) {
                    this.getEditUser.userOptions.map(item => {
                        if(item.option === 'EMAIL_TICKET_FORMAT') {
                            this.EMAIL_TICKET_FORMAT = item.value;
                        }
                    });
                }
            }
        },
        addEmailAddress(data) {
            if(data) {
                if(!data.rowid) {
                    var lastElement = this.userEmailCC.find((item, index) => { return this.userEmailCC.length === (index + 1); });
                    if(lastElement) {
                        if(Number.isInteger(lastElement.rowid)) {
                            data.rowid = lastElement.rowid + 1;
                            data.__modified__  = true;
                            data.__new__ = true;
                        } else {
                            data.rowid = 1;
                            data.__modified__  = true;
                            data.__new__ = true;
                        }
                    } else {
                        data.rowid = 1;
                        data.__modified__  = true;
                        data.__new__ = true;
                    }
                    this.userEmailCC.push(data);
                } else {
                    this.userEmailCC = this.userEmailCC.map(item => {
                        if(guidEqual(item.rowid, data.rowid)) {
                            data.__modified__ = true;
                            item = { ...item, ...data };
                        }
                        return item;
                    });
                }
            }
        },
        deleteEmailAddressDialog(item) {
            this.deleteUserDialog = true;
            this.selectedItems = item;
        },
        cancelDeleteEmailAddressDialog() {
            this.deleteUserDialog = false;
            this.selectedItems = null;
        },
        deleteEmailAddress(item) {
            this.userEmailCC = this.userEmailCC.map(data => {
                if(guidEqual(item.rowid, data.rowid)) {
                    data.deleted = true;
                    data.__modified__ = true;
                    this.deletedEmail.push(data);
                }
                return data;
            }).filter(data => !data.deleted);
            this.cancelDeleteEmailAddressDialog();
        },
        saveEmailSetting() {
            if(this.getEditUser) {
                if(this.getEditUser.userOptions) {
                    this.getEditUser.userOptions = this.getEditUser.userOptions.map(item => {
                        if(item.option === 'EMAIL_TICKET_FORMAT') {
                            item.value = this.EMAIL_TICKET_FORMAT;
                        }
                        return item;
                    });
                }
            }
            let allEmails = this.deletedEmail.concat(this.userEmailCC);
            this.$store.commit('SET_EDIT_USER', {
                ...this.getEditUser,
                email: this.email ? this.email : '',
                EMAIL_TICKET_FORMAT: this.EMAIL_TICKET_FORMAT,
                userEmailCC: allEmails,
            });
        },
        async editUser() {
            try {
                this.saveEmailSetting();
                let result = await webtmsBackend.updateUser({uid: this.$route.query.id, ...this.getEditUser});
                if(result.status === 'OK') {
                    if(this.getEditUser.account === this.getUserDetails.account) {
                        const getUserResult = await webtmsBackend.getUserObject(this.getUserDetails.uid);
                        this.$store.commit('SET_USER', getUserResult);
                    }
                    this.$store.dispatch('setSnackbar', { text: `User account "${result.user.name}" updated successfully.` });
                    this.$store.commit('SET_EDIT_USER', null);
                    this.$router.push('users');
                }
                if(result.err) {
                    this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
                }
            } catch(error) {
                this.$store.dispatch('setSnackbar', { color:'error', text: error });
            }
        }
    }
};
</script>
<style>
    .heading-title {
        font-weight: 500;
        font-size: 16px;
        color: #35383F;
    }
    .sub-heading-title {
        font-weight: 500;
        font-size: 14px;
        color: #35383F;
    }
    .content {
        font-weight: 400;
        font-size: 14px;
        color: #35383F;
    }
    .no-email {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #D5D8DE !important;
        box-sizing: border-box;
        border-radius: 4px;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
    }
</style>